import { render, staticRenderFns } from "./TabelaDeArquivos.vue?vue&type=template&id=2e040ecb"
import script from "./TabelaDeArquivos.vue?vue&type=script&lang=js"
export * from "./TabelaDeArquivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports